<script>
export default {
  name: 'VersionInfo',
  props: {
    system: {
      type: String,
      required: true,
    },
    latest: {
      type: String,
      default: '',
      required: false,
    }
  }
}
</script>

<template>
  <div class="version-info">
    <img 
      class="version-info__logo"
      src="@/assets/stage-logo.png"
      alt="Involves Stage - Logo"
    />
    <div class="version-info__version">
      {{ $t('yourVersion', { version: system }) }}
    </div>
    <div
      v-if="latest"
      class="version-info__version"
    >
      {{ $t('latestVersion', { version: latest }) }}
    </div>
  </div>
</template>

<style scoped>
.version-info {
  position: fixed;
  margin-top: var(--space-16);
  min-height: 88px;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.version-info__logo {
  margin-bottom: 10px;
  width: 125px;
  height: 36px;
}

.version-info__version {
  font-weight: bold;
  font-size: 12px;
  color: var(--color-system--white);
  line-height: normal;
}

@media (min-width: 400px) {
  .version-info {
    position: relative;
    z-index: var(--z-index-1);
  }
}

@media (min-height: 768px) {
  .version-info {
    position: fixed;
    bottom: 0;
    margin-top: 0;
  }
}
</style>